// extracted by mini-css-extract-plugin
module.exports = {"textPrimaryColor":"textPrimaryColor--l3xW5","textCenter":"textCenter--1kEd-","registerButton":"registerButton--cvz21"};